import { Directive, HostListener, Input } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
    selector: '[appNumberValidation]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NumberValidationDirective, multi: true }],
    standalone: false
})
export class NumberValidationDirective implements Validator {
  @Input() min: number;
  @Input() max: number;

  @HostListener('keyup', ['$event'])
  onKeyUp(e) {
    const value = e.target.value;
    if (value != '') {
      const numVal = parseInt(String(value));
      if (numVal < this.min || numVal > this.max) {
        e.target.value = this.validateNumberInput(numVal);
      }
    }
    e.preventDefault();
  }

  validate(control: UntypedFormControl) {
    if (control.value < this.min || control.value > this.max) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      control.patchValue(this.validateNumberInput(control.value), { emitEvent: false, onlySelf: true });
    }
    return null;
  }

  validateNumberInput(value: number) {
    const diffMin = Math.abs(this.min - value);
    const diffMax = Math.abs(this.max - value);
    // Choose either the min of max based on the least difference
    return diffMin >= diffMax ? this.max : value === null ? null : this.min;
  }
}
